var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.5V24.5H16.5V27.5H1.5C1.10218 27.5 0.720644 27.342 0.43934 27.0607C0.158035 26.7794 0 26.3978 0 26V2C0 1.60218 0.158035 1.22064 0.43934 0.93934C0.720644 0.658035 1.10218 0.5 1.5 0.5H28.5C28.8978 0.5 29.2794 0.658035 29.5607 0.93934C29.842 1.22064 30 1.60218 30 2V9.5H27V3.5H3ZM26.5605 12.9395L25.5 11.879L24.4395 12.9395L19.9395 17.4395L22.0605 19.5605L25.5 16.121L28.9395 19.5605L31.0605 17.4395L26.5605 12.9395ZM22.0605 21.9395L25.5 25.379L28.9395 21.9395L31.0605 24.0605L26.5605 28.5605L25.5 29.621L24.4395 28.5605L19.9395 24.0605L22.0605 21.9395Z",
    fill: "url(#paint0_linear_5286_6573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5286_6573",
    x1: 2.20693,
    y1: -4.18666,
    x2: 36.4764,
    y2: -1.03045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041923,
    stopColor: "#004CB2",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404358,
    stopColor: "#006DFF",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777658,
    stopColor: "#006DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownKey);
export default __webpack_public_path__ + "static/media/dropdown_key.9b65a58e2646f04fbc52a8f72667b530.svg";
export { ForwardRef as ReactComponent };